/**
 * Local Agreement: fusiona textos de chunks Whisper con overlap.
 */

/**
 * @param {string} s
 * @returns {string}
 */
export function normalizeAgreementText(s) {
  return String(s || '')
    .replace(/\s+/g, ' ')
    .replace(/\s+([.,;:!?])/g, '$1')
    .trim()
}

/**
 * Longitud del mayor sufijo de `a` que es prefijo de `b` (en tokens).
 * @param {string[]} a
 * @param {string[]} b
 * @returns {number}
 */
function suffixPrefixOverlapTokens(a, b) {
  const max = Math.min(a.length, b.length, 12)
  for (let n = max; n > 0; n--) {
    let ok = true
    for (let i = 0; i < n; i++) {
      const ta = String(a[a.length - n + i] || '')
        .toLowerCase()
        .replace(/[^a-z0-9áéíóúüñ]+/gi, '')
      const tb = String(b[i] || '')
        .toLowerCase()
        .replace(/[^a-z0-9áéíóúüñ]+/gi, '')
      if (!ta || !tb || ta !== tb) {
        ok = false
        break
      }
    }
    if (ok) return n
  }
  return 0
}

/**
 * Une chunk nuevo al texto acumulado, recortando solapes.
 * @param {string} committed
 * @param {string} chunkText
 * @returns {{ committed: string, draft: string }}
 */
export function mergeChunkAgreement(committed, chunkText) {
  const prev = normalizeAgreementText(committed)
  const next = normalizeAgreementText(chunkText)
  if (!next) return { committed: prev, draft: '' }
  if (!prev) return { committed: next, draft: '' }

  const a = prev.split(/\s+/).filter(Boolean)
  const b = next.split(/\s+/).filter(Boolean)
  const n = suffixPrefixOverlapTokens(a, b)
  const rest = b.slice(n).join(' ')
  const merged = normalizeAgreementText(
    rest ? `${prev} ${rest}` : prev
  )
  return { committed: merged, draft: '' }
}

/**
 * Acumulador para sesión live.
 */
export class LocalAgreementBuffer {
  constructor() {
    this.committed = ''
    this.draft = ''
  }

  reset() {
    this.committed = ''
    this.draft = ''
  }

  /**
   * Chunk confirmado por Whisper.
   * @param {string} text
   */
  pushConfirmed(text) {
    const r = mergeChunkAgreement(this.committed, text)
    this.committed = r.committed
    this.draft = ''
    return this.snapshot()
  }

  /**
   * Texto provisional (mientras infiere).
   * @param {string} text
   */
  setDraft(text) {
    this.draft = normalizeAgreementText(text)
    return this.snapshot()
  }

  snapshot() {
    const committed = this.committed
    const draft = this.draft
    const text = normalizeAgreementText(
      [committed, draft].filter(Boolean).join(' ')
    )
    return {
      committed,
      draft,
      finalText: committed,
      interimText: draft,
      text,
    }
  }
}

export default LocalAgreementBuffer
